import * as angular from 'angular';

import { ComponentDefinition, IValueViewModel, Pattern, IdentifierType, RefreshClickData } from '../../../models';
import { IIdentifierValuesStatusService, IExportToCsvService, IIdentifierVmService, IDateRangeService } from '../../../services';
import { IQualityAnalysisTableHelper } from '../../../widgets/QualityAnalysisTable/QualityAnalysisTable.helper';
import { refreshClick } from '../../../common/';


class ValidatedQualityStateController implements angular.IComponentController {
    isLoading: boolean;
    isLoadingData: boolean;
    selectedGroup: any;
    identifiers: IValueViewModel[];
    includeChildren: boolean;
    headings: {
        text: string;
        tootlip?: string;
        style?: { [index: string]: string | number };
        classed?: { [index: string]: boolean };
    }[];
    rows: any[];
    filteredRows: any[];
    displayedRows: any[];
    searchCriteria: Pattern<any>[];
    hasMore: boolean;
    hasLess: boolean;
    sort: any;
    searchString: string;
    private _pageSize = 48;
    private _currentPage = 0;
    private _viewModels: IValueViewModel[];
    private _data: { [index: string]: { [index: number]: number; }; };

    static $inject = [
        '$scope',
        '$stateParams',
        'identifierValuesStatusService',
        'exportToCsvService',
         'qualityAnalysisTableHelper', 
         'identifierVmService', 
         'dateRangeService'
    ];

    constructor(private _$scope: angular.IScope,
        private _$stateParams: angular.ui.IStateParamsService,
        private _statusService: IIdentifierValuesStatusService,
        private _exportToCsvService: IExportToCsvService,
        private _qualityAnalysisTableHelper: IQualityAnalysisTableHelper,
        private _identiferVmService: IIdentifierVmService,
        private _dateRangeService: IDateRangeService) {
    }

    $onInit() {
        this.searchString = this._$stateParams['searchString'];
        this.selectedGroup = this._$stateParams['selectedGroup'];
        this._$stateParams['selectedGroup'] = null;

        this.headings = [
            {
                text: 'Name'
            },
            {
                text: 'Tag'
            },
            {
                text: 'Group'
            },
            {
                text: 'Short comment'
            },
            {
                text: 'Unit'
            },
            {
                text: 'statusMissing',
                classed: {
                    'right-col': true
                }
            },
            {
                text: 'statusCorrected',
                classed: {
                    'right-col': true
                }
            }
        ];
        this.searchCriteria = [
            {
                label: 'Name',
                property: 'n',
                model: 'n',
                placeholder: 'Search pattern on name',
                isMatch: (entry, value) => {
                    return value.test(entry[0].item.name);
                }
            },
            {
                label: 'Tag',
                property: 't',
                model: 't',
                placeholder: 'Search pattern on tag',
                isMatch: (entry, value) => {
                    return value.test(entry[1].item.name);
                }
            },
            {
                label: 'Group',
                property: 'g',
                model: 'g',
                placeholder: 'Search pattern on group',
                isMatch: (entry, value) => {
                    return value.test(entry[2].item.absoluteName);
                }
            }, {
                label: 'Comment',
                property: 'c',
                model: 'c',
                placeholder: 'Search pattern on comment',
                isMatch: (entry, value) => {
                    return value.test(entry[0].item.shortComment);
                }
            }, {
                label: 'Unit',
                property: 'u',
                model: 'u',
                placeholder: 'Search pattern on unit',
                isMatch: (entry, value) => {
                    return value.test(entry[0].item.unitName);
                }
            },
            {
                label: 'Error',
                property: 'err',
                model: 'err',
                placeholder: 'Search pattern on error (missing, corrected)',
                isMatch: (entry, value) => {
                    let res = true;
                    if (value.test('missing')) {
                        res = entry[5].value > 0;
                    } else if (value.test('corrected')) {
                        res = entry[6].value > 0;
                    }
                    return res;
                }
            }
        ];
        this.sort = {
            err: {
                callback: (filter: RegExp) => {
                    if (filter.test('missing')) {
                        return (d: any) => d[5].value;
                    } else if (filter.test('corrected')) {
                        return (d: any) => d[6].value;
                    } else {
                        return (d: any) => d[3].value;
                    }
                },
                direction: 'desc'

            }
        };
        this.isLoadingData = true;
        this._identiferVmService.getAllViewModels()
            .then(data => {
                this.isLoadingData = false;
                this._viewModels = data.filter(d => d.identifierType === IdentifierType.Validated);
                this.refreshIdentifiers();
                if (this._dateRangeService.initialized()) {
                    return this.refresh(this._dateRangeService.beginDate() as string, this._dateRangeService.endDate() as string,
                        false);
                } else {
                    return;
                }
            })
            .then(() => {
                this._$scope.$watchGroup([() => this.selectedGroup, () => this.includeChildren], () => {
                    this.refreshIdentifiers();
                    this.rows =
                        this._qualityAnalysisTableHelper.mapValidatedDataToRows(this._data, this.identifiers);
                });

                this._$scope.$on(refreshClick, (event, data: RefreshClickData) => {
                    this.refresh(data.beginDate, data.endDate, data.force);
                });

                this._$scope.$watch(() => this.filteredRows, () => {
                    this._currentPage = 0;
                    this.updateDisplayedRow();
                });
            })
            .finally(() => this.isLoadingData = false);
    }

    refreshIdentifiers() {
        const selectedGroup = this.selectedGroup;
        const viewModels = this._viewModels;
        const includeChildren = this.includeChildren;
        this.identifiers =
            this._qualityAnalysisTableHelper.getIdentifiers(selectedGroup, viewModels, includeChildren);
    }

    private refresh(beginDate: string, endDate: string, force: boolean) {
        this.isLoadingData = true;
        return this._statusService
            .getBetweenDates(beginDate, endDate, IdentifierType.Validated, force)
            .then(rows => {
                this._data = rows;
                this.rows = this._qualityAnalysisTableHelper.mapValidatedDataToRows(rows, this.identifiers);
            })
            .finally(() => this.isLoadingData = false);
    }


    exportToCsv() {
        const data: string[][] = [];
        data.push(this.headings.map(d => d.text));
        this.rows.forEach(r => {
            const toAdd = r.map(c => c.type === 0 ? c.item.name : (c.type === 1 ? c.item.uniqueName : c.text));
            data.push(toAdd);
        });
        this._exportToCsvService.getCsvFromData(data, 'Validated identifiers in error.csv');
    }

    more() {
        this._currentPage++;
        this.updateDisplayedRow();
    }

    less() {
        this._currentPage--;
        this.updateDisplayedRow();
    }

    private updateDisplayedRow() {
        const displayCount = (this._currentPage + 1) * this._pageSize;
        this.displayedRows = this.filteredRows.slice(0, (displayCount));
        this.hasMore = displayCount < this.filteredRows.length;
        this.hasLess = this._currentPage > 0;
    }
}

export const wtValidatedQualityState: ComponentDefinition = {
    componentId: 'wtValidatedQualityState',
    controller: ValidatedQualityStateController,
    template: require('./validatedQualityState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
